import type { FieldSchemaModel } from '@/shared/generated'

import { filter, first, map, pipe, prop, propOr } from 'lodash/fp'

import { useColumnsSchemaQuery } from '@/entities/column'
import { useOptimizationQuery } from '@/entities/optimization'

import { HiddenOnContext, OptimizationStatus } from '@/shared/generated'

const getMainSourceInSchema: (schema: FieldSchemaModel[]) => string = pipe([
	filter(propOr(false, 'options.main')),
	map(prop('id')),
	first,
])

export function useMainSourceProperty(): string {
	const { data: prop } = useColumnsSchemaQuery<string>(
		HiddenOnContext.Assortment,
		{
			select: getMainSourceInSchema,
		}
	)

	return prop ?? 'last_price'
}
export function useOptimizationStatus(optimizationGroupId?: string | null) {
	const { data: optimization } = useOptimizationQuery(optimizationGroupId!, {
		enabled: !!optimizationGroupId,
	})

	return optimization?.status
}
export function useCanEditFinalPrice(optimizationGroupId: string): boolean {
	const status = useOptimizationStatus(optimizationGroupId)

	return status === OptimizationStatus.Finished
}
export function useCanEditModelInput(optimizationGroupId: string): boolean {
	const status = useOptimizationStatus(optimizationGroupId)

	return [
		OptimizationStatus.New,
		OptimizationStatus.Canceled,
		OptimizationStatus.Finished,
		OptimizationStatus.Failed,
		OptimizationStatus.Pending,
	].includes(status!)
}
